'use client'

import { motion } from 'framer-motion'
import { PolicyViolationsCard } from './PolicyViolationsCard'

interface PolicyViolationsViewProps {
  startDate: string
  endDate: string
  isLoading?: boolean
  targetEmployeeId?: number
  selectedProduct?: string
  selectedSite?: string
}

export function PolicyViolationsView({ startDate, endDate, isLoading = false, targetEmployeeId, selectedProduct, selectedSite }: PolicyViolationsViewProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className='space-y-6'
    >
      <div>
        <h2 className='text-2xl font-bold text-brand-navy mb-2'>AI Policy Checklist</h2>
        <p className='text-muted-foreground'>
          Track policy violations across all analyzed calls and export detailed reports
        </p>
      </div>

      <PolicyViolationsCard
        startDate={startDate}
        endDate={endDate}
        isLoading={isLoading}
        targetEmployeeId={targetEmployeeId}
        selectedProduct={selectedProduct}
        selectedSite={selectedSite}
      />
    </motion.div>
  )
}
